import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Wind } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import CreateVent from './CreateVent';

const FloatingVentButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Hide on Messages page
  const hiddenPaths = ['/app/messages'];
  const shouldHide = hiddenPaths.some(path => location.pathname.startsWith(path));

  if (shouldHide) {
    return null;
  }

  const handleVentCreated = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Floating Action Button with Curved Text */}
      <div className="fixed bottom-20 right-4 z-40 mb-[env(safe-area-inset-bottom,0px)]">
        {/* Curved Text Above Button */}
        <svg
          width="100"
          height="50"
          viewBox="0 0 100 50"
          className="absolute -top-8 left-1/2 -translate-x-1/2 pointer-events-none"
        >
          <defs>
            <path
              id="curve"
              d="M 10,45 Q 50,5 90,45"
              fill="transparent"
            />
          </defs>
          <text className="fill-primary text-[10px] font-medium">
            <textPath href="#curve" startOffset="50%" textAnchor="middle">
              Create a Vent
            </textPath>
          </text>
        </svg>

        <Button
          onClick={() => setIsOpen(true)}
          className="h-14 w-14 rounded-full shadow-lg bg-primary hover:bg-primary/90"
          size="icon"
          aria-label="Create a vent"
        >
          <Wind className="h-6 w-6" />
        </Button>
      </div>

      {/* Vent Creation Dialog */}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Create a Vent</DialogTitle>
          </DialogHeader>
          <CreateVent
            onVentCreated={handleVentCreated}
            onSuccess={handleVentCreated}
            onCancel={() => setIsOpen(false)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FloatingVentButton;
